import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { auth, db } from './firebase';
import { doc, getDoc } from 'firebase/firestore';
import AdminDashboard from './pages/AdminDashboard';
import GuestRSVP from './pages/RSVPPage';
import Login from './pages/Login';
import CoupleDashboard from './pages/CoupleDashboard';

function AuthRoute({ children, requiredRole }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (!user) {
        setLoading(false);
        navigate('/login');
        return;
      }
      const userDoc = await getDoc(doc(db, 'users', user.uid));
      const role = userDoc.exists() ? userDoc.data().role : null;
      if (requiredRole === 'admin') {
        setIsAuthorized(role === 'admin');
        if (role !== 'admin') navigate('/login');
      } else {
        setIsAuthorized(role !== 'admin' || !role);
        if (role === 'admin') navigate('/login');
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, [navigate, requiredRole]);

  if (loading) return <div></div>;
  return isAuthorized ? children : null;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/admin"
          element={
            <AuthRoute requiredRole="admin">
              <AdminDashboard />
            </AuthRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <AuthRoute requiredRole="couple">
              <CoupleDashboard />
            </AuthRoute>
          }
        />
        <Route path="/rsvp/:eventId" element={<GuestRSVP />} />
        <Route path="/couple" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
